var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.85 9.10168C17.9992 9.03587 18.1258 8.92774 18.2141 8.79068C18.3025 8.65363 18.3486 8.49367 18.347 8.33063C18.3453 8.16758 18.2958 8.00862 18.2046 7.87342C18.1135 7.73822 17.9847 7.63273 17.8342 7.57001L10.6917 4.31668C10.4745 4.21764 10.2387 4.16638 10 4.16638C9.76136 4.16638 9.52548 4.21764 9.30835 4.31668L2.16668 7.56668C2.01832 7.63166 1.89211 7.73846 1.80349 7.87403C1.71486 8.00959 1.66766 8.16805 1.66766 8.33001C1.66766 8.49198 1.71486 8.65043 1.80349 8.786C1.89211 8.92157 2.01832 9.02837 2.16668 9.09335L9.30835 12.35C9.52548 12.4491 9.76136 12.5003 10 12.5003C10.2387 12.5003 10.4745 12.4491 10.6917 12.35L17.85 9.10168Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.33337V13.3334",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.4166V13.3333C5 13.9963 5.52678 14.6322 6.46447 15.1011C7.40215 15.5699 8.67392 15.8333 10 15.8333C11.3261 15.8333 12.5979 15.5699 13.5355 15.1011C14.4732 14.6322 15 13.9963 15 13.3333V10.4166",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation2);
export default __webpack_public_path__ + "static/media/Education2.ef40194dcaf442934f2194331df0fee4.svg";
export { ForwardRef as ReactComponent };